import gsap, { Power1 } from 'gsap';
import { getXAccountingForAnchor } from './CoordinateCalculator';

/**
 * This is a fluent animation builder class to
 * simplify working with timelines. Add useful
 * animation helpers here if they are reusable.
 */
export default class Animator {
  target;
  timeline;

  /**
   * @param target
   * @param timeline
   */
  constructor(target, timeline) {
    this.target = target;
    this.timeline = timeline;
    this.innerTimeline = gsap.timeline();
    Object.entries(this.timeline.labels).forEach(([label, value]) =>
      this.innerTimeline.addLabel(label, value)
    );
    this.timeline.add(this.innerTimeline, 0);
  }

  /**
   * @param change
   * @param position
   * @returns {Animator}
   */
  to(change, position) {
    this.innerTimeline.to(this.target, change, position);
    return this;
  }

  /**
   * reverse out the animation on the parent timeline
   * @param startAt
   */
  reverseOut(
    startAt = this.timeline.labels.end - this.innerTimeline.duration()
  ) {
    this.innerTimeline
      .repeatDelay(startAt - this.innerTimeline.duration())
      .repeat(1)
      .yoyo(true);
    // Don't return 'this' because this should always be the last call in the chain
    // Adding more tweens to a reversed animation will have unexpected results
  }

  expandTo(item, duration, options = {}) {
    const { position, ease = Power1.easeOut } = options;
    const expand = {
      width: item.width,
      x: getXAccountingForAnchor(item),
      duration,
      ease,
    };
    return this.to(expand, position);
  }
}
